// extracted by mini-css-extract-plugin
module.exports = {"supportStyle":"_1dcQdkbRrAEtzj4dks8WY"};